import React from 'react';
import moment from 'moment';
const status = {
    'C': 'Cerrado',
    'O': 'Abierto'
}
const canceled = {
    'C': 'Cancelado'
}
const renderTableBody = (headers, data, checkbox, openDetails) => {
    const body = data.map((transferReq, index) => {
        return (
            <tr key={index}>
                {headers[0].value && <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{transferReq?.DocNum ?? ''}</td>}
                {headers[1].value && <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{transferReq?.Planta ?? ''}</td>}
                {headers[2].value && <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{transferReq?.Zonal ?? ''}</td>}
                {headers[3].value && <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{moment(transferReq?.DocDate ?? '').format('DD-MM-YYYY')}</td>}
                {headers[4].value && <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{canceled[transferReq?.CANCELED] ?? status[transferReq?.DocStatus] ?? '--'}</td>}

                <td class="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>
                    <button type="button" className="btn btn-timbra-one btn-sm botonCorrect"
                        onClick={() => openDetails(transferReq)}
                        style={{ fontWeight: '500' }}>
                        <i class="far fa-file-alt">
                        </i> Ver Detalles
                    </button>
                </td>
            </tr>
        )

    })
    return body;
};

const renderTable = (headers, data, checkbox, openDetails) => {

    let header = "";
    let body = "";

    if (headers.length !== 0) {
        header = <tr>
            {headers[0].value && <td style={{ textAlign: 'center', width: '10%' }}>{headers[0].title}</td>}
            {headers[1].value && <td style={{ textAlign: 'center' }}>{headers[1].title}</td>}
            {headers[2].value && <td style={{ textAlign: 'center' }}>{headers[2].title}</td>}
            {headers[3].value && <td style={{ textAlign: 'center' }}>{headers[3].title}</td>}
            {headers[4].value && <td style={{ textAlign: 'center' }}>{headers[4].title}</td>}
            <td class="sticky-columns" style={{ backgroundColor: "#e9ecef", textAlign: 'center' }}>Acciones</td>

        </tr>;
    }

    body = renderTableBody(headers, data, checkbox, openDetails);

    let table = "";

    table = <table id="dataTableTimbra" className="display" style={{ width: '100%' }}>
        <thead className="table-header">
            {header}
        </thead>
        <tbody>
            {body}
        </tbody>
    </table>;

    return table;

};

export const renderReabsResume = (headers, data, checkbox, openDetails) => {

    return renderTable(headers, data, checkbox, openDetails);

}